<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container">
      <a class="navbar-brand" href="#">
        <img :src="logoSrc" alt="Logo" class="navbar-logo" />
      </a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto">
          <!-- Only show Home link if authenticated -->
          <li v-if="authStore.isAuthenticated" class="nav-item">
            <router-link class="nav-link" to="/home">Home</router-link>
          </li>
          <li v-if="authStore.isAuthenticated && authStore.isAdmin" class="nav-item">
            <router-link class="nav-link" to="/users">User Management</router-link>
          </li>
          <li v-if="authStore.isAuthenticated" class="nav-item">
            <router-link class="nav-link" to="/logout">Logout</router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/authStore';

const logoSrc = require('@/assets/logo-cropped.webp');

const authStore = useAuthStore()
</script>

<style scoped>
.navbar-brand {
  display: flex;
  align-items: center;
  height: 100%; 
  padding: 0;
}

.navbar-logo {
  height: 40px;
  width: auto;
  object-fit: cover;
  object-position: center;
}

@media (max-width: 992px) {
  .navbar-logo {
    height: 40px;
  }
}
</style>